module.exports = __webpack_public_path__ + "static/img/six3.32d32ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/six3.png
// module id = 6iUM
// module chunks = 25